import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { loader, customerOffer } from '../Store/actions/customerInfoActions';
import { insertEligibleOffers } from '../services/analytics';
import languages from '../services/languages';
import { getConversationStatus } from '../services/utils';
import countries from '../services/countries';

const useCustomerOfferFetch = (contextData: any, isCIP: boolean, CIP_DOMAIN: string, reload: any, agentSiteLocation: string) => {
  const { jcAuthData, ocAppData, ocPlatformData } = contextData;
  const { closedPhoneCall, closedConversation } = ocAppData;
  if(false) console.log(CIP_DOMAIN, agentSiteLocation)
  const { callInfo: { assignedAgent = undefined, multipleAgentsConnected = undefined } = {} } = ocPlatformData;
  const interactionClosed = getConversationStatus(closedPhoneCall, closedConversation, multipleAgentsConnected, assignedAgent);
  console.log('Interaction Closed?', interactionClosed);
  const countryWithCode = jcAuthData.country ? jcAuthData.country : jcAuthData.countryCode ? jcAuthData.countryCode : jcAuthData.surfaceIpRegion;
  const country = countries[countryWithCode];
  const { modifiedCustomer: { rengaId: userId = '', contactId = '' } = {} } = ocAppData || {};
  const dispatch = useDispatch();
  const CIPData: any = useSelector((state: any) => state.customerInfo.CIP_data);
  const { currentContactId }: any = useSelector((state: any) => state.customerInfo);
  const [
    { 'Renga ID': [ciprengaId = ''] = [''], 'Active Subscription Plan': activeSubscription = [''] } = {},
    {
      'Bot Intent': [botIntent = ''] = [''],
      'Queue Path': queuePath = [''],
      'CustomerOne Sub-Issue': [subissueType = ''] = [''],
      'Number of Transfers': [transferCount = ''] = [''],
    } = {},
  ] = CIPData;
  const NoTransferCount: number = Number(transferCount);
  
  useEffect(() => {
    let isMounted = true;
    const source = axios.CancelToken.source();
    dispatch(customerOffer(isCIP, [{ features: [], meta: [], entitlement: [], cctPro: false }]));
    return () => {
      isMounted = false;
      source.cancel();
    };
  }, [userId, reload]);
};

export default useCustomerOfferFetch;
